import { SUPPORTED_EXCHANGES } from "@cede/types";

/**
 * DEX exchanges that support the Cede Hub /trade page.
 * Only Hyperliquid has trade page integration — other DEXs (GRVT, 01.xyz, etc.)
 * are only available via the perps algo trade page.
 */
const TRADE_SUPPORTED_DEXES: ReadonlySet<string> = new Set([SUPPORTED_EXCHANGES.HYPERLIQUID]);

/** Check whether an exchange supports the /trade page redirect. */
export function canTradeOnExchange(exchangeId: string, accountType: "cex" | "dex"): boolean {
  if (accountType === "cex") return true;
  return TRADE_SUPPORTED_DEXES.has(exchangeId);
}
